<template>
	<div class="text-center">
		<IconFolderPlus class="mx-auto h-16 w-16 text-surface-400 dark:text-surface-500" :stroke-width="1"/>
		<h3 class="mt-2 text-sm font-semibold text-surface-900 dark:text-surface-100">{{ getTitle }}</h3>
		<p class="mt-1 text-sm text-surface-500 dark:text-surface-300">{{ getDescription }}</p>
		<div class="mt-6">
			<Button :label="getCreateLabel" @click="$emit('on-create')"/>
		</div>
	</div>
</template>

<script>
import { IconFolderPlus } from "@tabler/icons-vue";

export default {
	name: "EmptyState",
	components: {
		IconFolderPlus,
	},
	props: {
		createLabel: {
			type: String,
			default: 'Create'
		},
		title: {
			type: String,
			default: 'No records available'
		},
		description: {
			type: String,
			default: 'Get started by creating a new record.'
		},
	},
  computed: {
    getCreateLabel() {
      return this.createLabel ?? this.$t('components.empty_state.create')
    },
    getTitle() {
      return this.title ?? this.$t('components.empty_state.no_records_available')
    },
    getDescription() {
      return this.description ?? this.$t('components.empty_state.get_started_by_creating_a_new_record')
    },
  },
}
</script>
